import type { GQLLocale } from 'graphql-ts-types';

import { useFetchValidations } from '../../components/DynamicForm/hooks/fetch-validations';
import type { GqlValidationRules } from '../../components/DynamicForm/types';
import { executeQuery } from '../../gql';
import type {
  EmailValidationRulesQuery,
  EmailValidationRulesQueryVariables,
} from '../../gql/generated/schema';
import { combineQueryWithFragments } from '../../gql/utils/fragments';
import baseValidationRuleAttributes from '../../hooks/validation-rules/gql/fragment/baseValidationRuleAttributes.gql';
import validationRuleAttributes from '../../hooks/validation-rules/gql/fragment/validationRuleAttributes.gql';
import validationRuleGroupAttributes from '../../hooks/validation-rules/gql/fragment/validationRuleGroupAttributes.gql';
import emailValidationRulesQuery from '../../hooks/validation-rules/gql/query/emailValidationRules.gql';
import { captureMessage } from '../../utils/error-reporter';

const fetchEmailRules = async (locale: GQLLocale) => {
  try {
    const { validationRules } = await executeQuery<
      EmailValidationRulesQuery,
      EmailValidationRulesQueryVariables
    >({
      query: combineQueryWithFragments(
        emailValidationRulesQuery,
        baseValidationRuleAttributes,
        validationRuleAttributes,
        validationRuleGroupAttributes
      ),
      variables: { locale },
    });

    return validationRules.email as GqlValidationRules;
  } catch (error) {
    captureMessage(`Failed to fetch the email validation rules. ${error}`);
  }
};

export const useEmailGqlValidations = () => useFetchValidations(fetchEmailRules);
